import React from 'react';
import { Input, Button, Tooltip } from '@heroui/react';
import { FilterSelect, ResponsiveTooltip } from '../../../../components/ui';
import { useTranslations } from '../../../../contexts/translation.context';
import {
  SearchInputIc,
  DangerIc,
  ResetFiltersIc,
  WidgetIc,
  StatusFilterOrdersIc,
  OfferFilterIc,
  LinkIcon,
  PublicLinkIc,
} from '../../../../components/icons';
import { getOrderStatuses } from '../constants';
import { FiltersProps } from '../types';
import { CustomHeroButton } from '../../../../components';

const FiltersSection: React.FC<FiltersProps> = ({
  filters,
  localSearch,
  availableOffers,
  offersLoading,
  hasActiveFilters,
  onSearchChange,
  onFilterChange,
  onResetFilters,
  onPublicLinksClick,
}) => {
  const { t } = useTranslations();

  const offerOptions = [
    { key: 'all', label: t('partner.orders.filters.offer.label') },
    ...availableOffers.map((offer) => ({
      key: offer.id,
      label: `${offer.name}`,
    })),
  ];

  return (
    <div className="px-4 pb-6 md:px-6 md:pb-6 flex items-center gap-4 flex-wrap justify-between w-full">
      <div className="flex items-center gap-4 md:flex-wrap md:justify-start max-md:h-10 [&>*]:shrink-0 max-md:overflow-x-auto max-md:px-4 max-md:-mx-4 scroller-none">
        <Input
          type="text"
          placeholder={t('partner.orders.filters.search.placeholder')}
          size="sm"
          value={localSearch}
          onChange={(e) => onSearchChange(e.target.value)}
          endContent={<SearchInputIc />}
          classNames={{
            mainWrapper: 'w-[17.0625rem]',
            base: 'w-[17.0625rem]',
            input: 'text-sm',
            inputWrapper: 'rounded-lg h-9 w-[17.0625rem]',
          }}
        />
        <FilterSelect
          placeholder={t('partner.orders.filters.offer.placeholder')}
          options={offerOptions}
          selectedKey={filters.offer}
          variant="campaign"
          onSelectionChange={(value) => onFilterChange('offer', value)}
          startContent={<OfferFilterIc />}
          autoWidth={true}
          showPlaceholderWithValue={true}
          //@ts-ignore
          isLoading={offersLoading}
        />
        <FilterSelect
          placeholder={t('partner.orders.filters.status.placeholder')}
          options={getOrderStatuses(t)}
          selectedKey={filters.status}
          variant="campaign"
          onSelectionChange={(value) => onFilterChange('status', value)}
          startContent={<StatusFilterOrdersIc size={20} />}
          autoWidth={true}
          showPlaceholderWithValue={true}
        />
        {!hasActiveFilters && <div className="shrink-0 w-10 h-2 md:hidden"></div>}
        {hasActiveFilters && (
          <Tooltip content={t('partner.orders.filters.resetTooltip')} placement="top">
            <Button
              //@ts-ignore
              size="xs"
              className="h-9 rounded-2 !w-9 p-0 bg-auth-surface shrink-0"
              onPress={onResetFilters}
            >
              <ResetFiltersIc />
            </Button>
          </Tooltip>
        )}
      </div>

      <CustomHeroButton
        onPress={onPublicLinksClick}
        startContent={<PublicLinkIc />}
        title={t('partner.orders.publicLinks')}
      />
    </div>
  );
};

export default FiltersSection;
